export enum MethodEnum {
  CAD = 'CAD',
  EDIT = 'EDIT',
  EXC  = 'EXC',
  AIT  = 'AIT',
  LIST  = 'LIST',
  NOTHING = 'NOTHING'
}
